import useFetchContract from "./use-fetch-contract";

const pipedriveURL = "prefill/pipedrive";

export default function usePrefill() {
  const { isLoading, error, get } = useFetchContract();

  const getPrefill = async (id: string, entity: string) => {
    const res = (await get(`${pipedriveURL}/${entity}/${id}`)) as any;

    return res.data;
  };

  // const getPrefillFromPipedrive = async (data: string) => {
  //   const res = (await get(`${pipedriveURL}/${data}`)) as any;

  //   return res.data;
  // };

  return {
    isLoading,
    error,
    getPrefill,
  };
}
